<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M16.6668 5L7.50016 14.1667L3.3335 10"
            stroke="currentColor"
            stroke-width="3"
            stroke-linejoin="round"
        />
    </svg>
</template>
